import digitalData from "@/digitalData";

describe("digitalData config", () => {
  it("configuracion exportada por defecto", () => {
    expect(digitalData).toBeDefined();
    expect(digitalData).not.toBeNull();
    expect(digitalData).toBeInstanceOf(Object);
  });
});
